import React, { useState, useRef, useEffect } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { auditByStatusByDateOptions } from "../../../graphql/audit/custom-queries";
import { useNotify } from "react-admin";
import { format } from "date-fns";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  ListItemSecondaryAction,
  IconButton,
  Divider,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { grey, green } from "@material-ui/core/colors";
import { Link } from "react-router-dom";
import {
  AuditOutlinedIcon,
  ChevronRightIcon,
  RefreshIcon,
  XIcon,
} from "../../../components/common/iconography";
import { AuditStatus } from "../../../utils/constants";
import { logError } from "../../../utils/appUtils";
import CrewCard from "../../../components/common/CrewCard";

const useStyles = makeStyles((theme) => ({
  grey: {
    color: theme.palette.getContrastText(grey[200]),
    backgroundColor: grey[200],
  },
  green: {
    color: theme.palette.getContrastText(green[200]),
    backgroundColor: green[200],
  },
  link: {
    color: "inherit",
    textDecoration: "inherit",
  },
  unprocessedItem: {
    color: theme.palette.getContrastText(grey[200]),
    backgroundColor: grey[300],
  },
  notFound: {
    display: "fles",
    margin: theme.spacing(2),
  },
}));

const AuditList = ({ match }) => {
  const isComponentMounted = useRef(true);
  const [audits, setAudits] = useState([]);
  const [, setSelectedAudit] = useState();
  const classes = useStyles();
  const notify = useNotify();

  useEffect(() => {
    if (isComponentMounted) getAudits();
    return () => (isComponentMounted.current = false);
  }, []);

  const getAudits = async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(auditByStatusByDateOptions, {
          reloadYardId: window.appUser?.reloadYardId,
          sortDirection: "DESC",
          statusCreateDateTime: {
            beginsWith: { status: AuditStatus.IN_PROGRESS },
          },
        })
      );
      const auditResponse = response.data.auditByStatusByDate.items;
      setAudits(auditResponse);
    } catch (err) {
      logError("pages:audit:AuditList:getAudits", err, notify);
    }
  };

  const getAvatarClassName = (shipment) => {
    if (shipment.state === AuditStatus.NEW) return classes.green;
    return classes.unprocessedItem;
  };

  const handleSelect = async (audit) => {
    setSelectedAudit(audit);
  };

  return (
    <CrewCard
      title="Audit"
      icon={<AuditOutlinedIcon fontSize="large" />}
      action={
        <IconButton onClick={getAudits}>
          <RefreshIcon fontSize="large" />
        </IconButton>
      }
    >
      {audits?.length > 0 ? (
        <List>
          {audits.map((audit, idx) => {
            return (
              <div key={audit.id}>
                <Link className={classes.link} to={match.path + "/" + audit.id}>
                  <ListItem onClick={() => handleSelect(audit)}>
                    <ListItemAvatar>
                      <Avatar className={getAvatarClassName(audit)}>
                        <XIcon fontSize="inherit" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <>
                          <Typography>{audit.accountName}</Typography>
                          <Typography color="textSecondary">
                            {audit.assignedTo}
                          </Typography>
                        </>
                      }
                      secondary={format(
                        new Date(audit.createDateTime),
                        "MM/dd/yyyy hh:mm a"
                      )}
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        onClick={() => handleSelect(audit)}
                      >
                        <ChevronRightIcon fontSize="large" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                </Link>
                {idx < audits.length - 1 ? <Divider /> : null}
              </div>
            );
          })}
        </List>
      ) : (
        <Typography className={classes.notFound}>No audits found.</Typography>
      )}
    </CrewCard>
  );
};

export default AuditList;
